import React, { useRef, useEffect } from 'react';
import { Form, Input, DatePicker } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { observer } from 'mobx-react-lite';
import ModuleView from '../../ModuleView';

const FormItem = Form.Item;

// 仅社招
function Patent(props) {
  const formRefs = useRef<any[]>([]);
  const { data } = props;
  const { socialResumeDetail, socialResumeFormRefStore } = useRootStore();

  const store = socialResumeDetail;
  const storeRef = socialResumeFormRefStore;

  useEffect(() => {
    storeRef.changeRef('resumePatentListRef', formRefs.current);
  }, [data, data?.length]);

  const handleValueChange = (index: string, formItemKey: string, formItemValue: any) => {
    store.setResumePatentList(index, formItemKey, formItemValue);
  };

  return (
    <div className="patent_edit model_edit">
      <div className="model_title">专利</div>
      {data?.map((item, index) => (
        <div className="model_list" key={Math.random()}>
          <Form
            ref={(el) => {
              formRefs.current[index] = el;
            }}
            className="modal_form"
            defaultFieldsValue={item}
            onFieldValueChange={(formItemKey, formItemValue) => handleValueChange(index, formItemKey, formItemValue)}
          >
            <FormItem formItemKey="patentName" span="11" labelWidth={0} required message="请填写专利名称">
              <div className="label">
                专利名称<span className="icon">*</span>
              </div>
              <Input toFormItem size="large" placeholder="请输入专利名称" />
            </FormItem>
            <FormItem formItemKey="ownerName" span="11" labelWidth={0}>
              <div className="label">专利人</div>
              <Input toFormItem size="large" placeholder="请输入专利人" />
            </FormItem>
            <FormItem formItemKey="obtainDate" span="11" labelWidth={0}>
              <div className="label">取得日期</div>
              <DatePicker
                toFormItem
                size="large"
                placeholder="请选择"
                format="YYYY/MM"
                valueFormat="timestamp"
                disabledDate={(cur) => {
                  // 当前时间加一个月
                  return cur > Number(new Date()) + 2592000000;
                }}
              />
            </FormItem>
            <FormItem formItemKey="patentUrl" span="11" labelWidth={0}>
              <div className="label">专利链接</div>
              <Input toFormItem size="large" placeholder="请输入专利链接" />
            </FormItem>
            <FormItem formItemKey="description" span="11" labelWidth={0}>
              <div className="label">专利描述</div>
              <Input.TextArea
                toFormItem
                className="input_text_area"
                placeholder="请输入专利描述"
                showCount
                maxLength={2000}
                autosize={{ minRows: 2, maxRows: 6 }}
              />
            </FormItem>
          </Form>
          <div className="delete-list">
            <div onClick={() => store.deleteResumeList('resumePatentList', index)}>删除这段信息</div>
          </div>
        </div>
      ))}
      <div
        className="list_add"
        onClick={() => {
          store.addResumeList('resumePatentList');
        }}
      >
        <div className="add_icon">
          <img src={require('@imgs/add.svg')} alt="" />
        </div>
        添加专利
      </div>
    </div>
  );
}

export default ModuleView(observer(Patent), 'patent');
